import { render, staticRenderFns } from "./ClaimList.vue?vue&type=template&id=610ef5c2&scoped=true"
import script from "./ClaimList.vue?vue&type=script&lang=js"
export * from "./ClaimList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ef5c2",
  null
  
)

export default component.exports